// //子导航
// $(function () {
//   //
//   let hoverNavId = "";
//   //
//   // $(".app-nav-wrap .app-nav-item").click(
//   //   function () {
//   //     console.log("22222222222222222222");
//   //     hoverNavId = $(this).attr("data-id");
//   //     toggerSubNav();
//   //   },
//   //   function () {
//   //     hoverNavId = "";
//   //     toggerSubNav();
//   //   }
//   // );

//   $(".app-nav-wrap .app-nav-item").on(
//     "click",
//     function () {
//       console.log("22222222222=====");
//       hoverNavId = $(this).attr("data-id");
//       toggerSubNav();
//     },
//     function () {
//       hoverNavId = "";
//       toggerSubNav();
//     }
//   );

//   //
//   $(".app-sub-nav-group-wrap").click(
//     function () {
//       clearTimeout(timeout);
//     },
//     function () {
//       hoverNavId = "";
//       toggerSubNav();
//     }
//   );
//   //
//   let timeout = null;
//   const toggerSubNav = () => {
//     console.log("112222211111", hoverNavId);
//     clearTimeout(timeout);
//     timeout = setTimeout(() => {
//       hideSubNav();

//       if (hoverNavId) {
//         const $links = $(
//           `.app-sub-nav-group-item[data-id="${hoverNavId}"] a.app-sub-nav-item`
//         );
//         console.log("eee", $links);
//         if ($links.length > 0) {
//           $(
//             `.app-sub-nav-group-wrap, .app-sub-nav-group-item[data-id="${hoverNavId}"]`
//           ).removeClass("hide");
//         }
//       }
//     }, 100);
//   };
//   const hideSubNav = () => {
//     $(".app-public-sub-header")
//       .find(".app-sub-nav-group-wrap .app-sub-nav-group-item")
//       .addClass("hide");
//   };
// });

$(function () {
  let hoverNavId = "";
  $(".app-nav-wrap .app-nav-item").on("click", function () {
    hoverNavId = $(this).attr("data-id");
    if (hoverNavId == 2) {
      $(".app-sub-nav-group-item").removeClass("hide");
      $(".app-sub-nav-group-item5").addClass("hide");
    }
    if (hoverNavId == 5) {
      $(".app-sub-nav-group-item5").removeClass("hide");
      $(".app-sub-nav-group-item").addClass("hide");
    }
  });

  $(".showMenu").on("click", function () {
    $(".app-nav-wrap").removeClass("hide");
    $(".hideColor").removeClass("hide");
  });
  $(".hideColor").on("click", function () {
    $(".app-nav-wrap").addClass("hide");
    $(".hideColor").addClass("hide");
    $(".app-sub-nav-group-item5").addClass("hide");
    $(".app-sub-nav-group-item").addClass("hide");
  });
});
